import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Button from '@mui/material/Button';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import useResourceFiltersStore from 'graph/state/query-hooks/use-resource-filters';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import { FilterGroup } from '@monorepo/shared/src/providers/ResourcesProvider/types';
import ResourcesSearchFilter from './ResourceSearchFilter';
import DropDownFilter from './DropDownFilter';

const ResourceFilters: React.FC = () => {
  const [{ filters }, { removeAllResourceFilters, setResourceFilters }] = useResources();
  const [store] = useResourceFiltersStore();

  const classes = useStyles();

  useEffect(() => {
    setResourceFilters(store.filters);
  }, [store.isLoading, store.filters]);

  return (
    <div className={classes.topLevelParentDiv}>
      <div className={classes.filtersDiv}>
        <ResourcesSearchFilter />
        {Object.keys(filters as FilterGroup).map((filterKey) => (
          <DropDownFilter key={filterKey} filter={(filters as FilterGroup)[filterKey]} />
        ))}
        <div className={classes.clearFiltersDiv}>
          <Button
            startIcon={<FontAwesomeIcon icon={faTimes} size="lg" />}
            className={classes.clearFiltersButton}
            onClick={removeAllResourceFilters}
          >
            <span className={classes.clearFiltersButtonText}>Clear Filters</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: any) => ({
  clearFiltersButton: {
    color: theme.palette.link.main,
    margin: '10px 0px',
    width: '158px',
  },
  clearFiltersButtonText: { marginTop: 5 },
  clearFiltersDiv: {
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '12px',
    lineHeight: '18px',
    paddingTop: '20px',
  },
  filtersDiv: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'row wrap',
  },
  topLevelParentDiv: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    minHeight: '90px',
  },
}));

export default ResourceFilters;
